module.exports = __webpack_public_path__ + "img/softball.7f28346f.svg";